/* eslint-disable react/jsx-props-no-spreading */
/*
 * Copyright (c) 2022, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import React from 'react';
import {
  CardContent as MUICardContent,
  CardContentProps as MUICardContentProps,
  withStyles,
  Theme,
} from '@material-ui/core';
import clsx from 'clsx';

interface CustomCardContentProps extends MUICardContentProps {
  paddingSize?: 'md' | 'lg';
  classes?: Record<string, string>;
  fullHeight?: boolean;
}

const styles = (theme: Theme) => ({
  rootLg: {
    padding: theme.spacing(3),
    '&:last-child': {
      paddingBottom: theme.spacing(3),
    },
  },
  rootMd: {
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  fullHeight: {
    height: '100%',
  },
});

const CardContent = withStyles(styles)(
  ({
    children,
    paddingSize = 'lg',
    fullHeight,
    classes,
    ...rest
  }: CustomCardContentProps) => (
    <MUICardContent
      className={clsx(
        paddingSize === 'lg' ? classes?.rootLg : classes?.rootMd,
        fullHeight ? classes?.fullHeight : ''
      )}
      {...rest}
    >
      {children}
    </MUICardContent>
  )
);

export default CardContent;
